import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full sm:w-1/2 xl:w-1/3" }
const _hoisted_2 = { class: "border-teal p-8 border-t-12 mb-6 rounded-lg shadow-lg bg-white" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { class: "font-bold text-grey-darker block mb-2" }, "Password", -1)
const _hoisted_5 = { class: "flex flex-col gap-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createVNode("input", {
          type: "password",
          class: "block appearance-none w-full bg-white border border-grey-light hover:border-grey px-2 py-2 rounded shadow",
          placeholder: "Your password",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.password = $event))
        }, null, 512), [
          [_vModelText, _ctx.password]
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("a", {
          onClick: _cache[2] || (_cache[2] = $event => (_ctx.handleUpdateUser({ password: _ctx.password }))),
          href: "#",
          class: "btn-black",
          tabindex: "0"
        }, " Update password ")
      ])
    ])
  ]))
}